import React from 'react';
import { ItemPath } from '../../../../order.schema';
import ServicesSection from '../../ItemTypes/Service/ServicesSection';

interface FormServiceProps {
  itemPath: ItemPath;
}

export const FormService: React.FC<FormServiceProps> = ({ itemPath }) => {
  return (
    <>
      <ServicesSection itemPath={itemPath} />
    </>
  );
};